import React from "react";
import CrudEditor from "./admin/CrudEditor";

export default function AdminProducts() {
  return (
    <CrudEditor
      title="Products"
      subtitle="Manage the product cards displayed on your Products page."
      endpoint="/products"
      testKey="products"
      emptyItem={{ name: "", category: "", tagline: "", description: "", features: [], image_url: "", order: 0 }}
      fields={[
        { key: "name", label: "Name", type: "text" },
        { key: "category", label: "Category", type: "text" },
        { key: "tagline", label: "Tagline", type: "text" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "image_url", label: "Image URL", type: "text" },
        { key: "features", label: "Features (one per line)", type: "list" },
        { key: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
